module.exports = __webpack_public_path__ + "static/media/uerre-grey.49025a07.svg";